import type { SearchResultLocationV5 } from '@seek/chalice-types';
import { getByID } from '@seek/location-data';

import { logger } from 'src/modules/logger';

export const getShortLocationName = (
  languageCode: 'en' | 'id' | 'th' | 'zh',
  locationId?: SearchResultLocationV5['whereId'],
) => {
  if (!locationId || languageCode === 'zh') {
    return null;
  }

  const locationData = getByID(Number(locationId));
  if (locationData.error !== null) {
    logger.error(
      {
        input: { locationId },
      },
      'Location ID not found!',
    );
    return null;
  }

  const kind = locationData.value.kind;
  const name = locationData.value.name(languageCode);

  switch (kind) {
    case 'SEEKLocation':
    case 'Suburb': {
      if (
        !locationData.value.state ||
        !locationData.value.state.abbreviation(languageCode)
      ) {
        return name;
      }

      return `${name} ${locationData.value.state.abbreviation(languageCode)}`;
    }
    case 'Country':
    case 'State':
    default:
      return name;
  }
};
